export default "__VITE_ASSET__C5CR91$t__"